import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=53e6b126&scoped=true"
import script from "./appointmentList.js?vue&type=script&lang=js&external"
export * from "./appointmentList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6b126",
  null
  
)

export default component.exports